module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAoCAYAAAAR87HlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgB7dZRCYAwFIXhgwmMsAhGMYJRbKANtgZGGCZYBCMYYd4L90F89Qwc7oeDPn34IFOAVM55kEWwMvDQKxgZeMpGMBLI2RNOYPRvcAajBn4T7GWpga9RBQNYCeZLgBuIdbJdpqe3AzM9xuxFd2BWEp4bXD/cg5nBqcEKr6XgQP3BfcAe7KqEIx2+fYkXMDN40vsLZPR49h8lnwwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/templates-left-arrow.png
// module id = rE/R
// module chunks = 1